import classes from "./LabelValue.module.css";
import clsx from "clsx";
import { MdModeEdit } from "react-icons/md";
const LabelValue = ({
  value = "ACNCC",
  label,
  className,
  labelClass,
  valueClass,
  LabelTag = "h2",
  ValueTag = "p",
  children,
  isEdit,
  onClick=()=>{}
}) => {
  return (
    <div className={clsx(classes.wrapper, className)}>
      <div className={classes.labelWrapper}>
        <LabelTag className={clsx(labelClass, classes.heading)}>
          {label}
        </LabelTag>
        {isEdit && (
          <span className={classes.btn} onClick={onClick}>
            <MdModeEdit />
          </span>
        )}
      </div>
      <ValueTag className={valueClass}>{value}</ValueTag>
      {children}
    </div>
  );
};

export default LabelValue;
